import axios from 'axios'

export default async (app) => {
  const getConfigFile = async function (carrier) {
    let success = false
    let prefix = process.env.VUE_APP_MODULE_PREFIX
    if (prefix !== '/') {
      prefix = prefix + '/'
    }
    await axios.get(prefix + `config.json`)
      .then((response) => {
        if (response.data.apiUrl === undefined || typeof response.data != 'object') {
          console.log('error in get config', response.data)
          app.$router.push('internal-error')
        } else {
          let dataString = JSON.stringify(response.data)
          dataString = dataString.replaceAll('/SPA_NAME', process.env.VUE_APP_MODULE_PREFIX)
          dataString = dataString.replaceAll('CARRIER', carrier.toUpperCase())

          app.$store.commit('setConfigUrls', JSON.parse(dataString))
          success = true
        }
      })
      .catch((e) => {
        console.log('error in get config', e)
        app.$router.push('internal-error')
      })
      .finally(() => {
        return success
      })
  }

  const findCarrierInHost = function () {
    // eslint-disable-next-line no-useless-escape
    let matches = location.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)
    let carrier = matches[1].split('-')[1]
    if (carrier.search(/\./) !== -1){
      return carrier.split('.')[0]
    }else{
      return carrier
    }
  }

  let location = window.location.href
  if (location) {
    let queryRoute = app.$route.query
    let carrier = queryRoute.carrier

    if (carrier === undefined) {
      let storeCarrier = app.$store.getters.getCarrier
      carrier =  storeCarrier !== ''  ?  storeCarrier : findCarrierInHost()
    }
    app.$store.commit('setCarrier', carrier)
    await getConfigFile(carrier)
  }
}
